import { createSlice } from '@reduxjs/toolkit'

export interface IMatchListMeetingsDataState {
    pagination: {
        itemsPerPage: number
        currentPage: number
        total: number
    }
    searchValue: string | null
    filters?: any
    sort?: string
    projection?: any
    needPopulate: boolean
    populates?: any
}

const initialState: IMatchListMeetingsDataState = {
    pagination: {
        itemsPerPage: 10,
        currentPage: 1,
        total: 0
    },
    searchValue: null,
    filters: {},
    sort: '-createdAt',
    projection: [],
    needPopulate: true,
    populates: []
}

const matchListMeetingsSlice = createSlice({
    name: 'ui/match-list-meetings',
    initialState,
    reducers: {
        onChangePagination(state, acion) {
            state.pagination = { ...state.pagination, ...acion.payload }
        },
        onChangeSearch(state, action) {
            state.searchValue = action.payload
        },
        onChangeTotal(state, action) {
            state.pagination = { ...state.pagination, total: action.payload }
        },
        onChangeFilters(state, action) {
            const objectkeys = Object.keys(action.payload)
            for (const key of objectkeys) {
                state.filters[key] = action.payload[key]
            }
        }
    }
})

export const matchListMeetingsActions = matchListMeetingsSlice.actions
export default matchListMeetingsSlice.reducer
